import { isArray, isNil, isObject } from 'lodash/fp';
import { Yup } from 'app/components/core/Form';
import { hasRhs, isDate, isNumeric, OPS, isBoolean } from 'app/lib/utils/sql';

const TYPE_TEST = {
    name: 'type check',
    skipAbsent: false,
    message: 'workbench:Explorer.dialog.errors.typeMismatch',
    test(value, context) {
        const { column, operator, isRelative } = context.parent;
        if (
            isNil(column) ||
            isRelative ||
            operator?.name === OPS.IS_NULL ||
            operator?.name === OPS.IS_NOT_NULL
        ) {
            return true;
        }

        if (isArray(value) && isNumeric(column.type)) {
            return Yup.array().of(Yup.number()).isValidSync(value);
        } else if (isDate(column.type) && [OPS.BETWEEN, OPS.NOT_BETWEEN].includes(operator?.name)) {
            return Yup.array().length(2).of(Yup.date()).isValidSync(value);
        } else if (isObject(value) && value?.isLiteral) {
            if (isNumeric(column.type)) {
                return Yup.number().isValidSync(value?.name);
            }

            if (isDate(column.type)) {
                return Yup.date().isValidSync(value?.name);
            }

            return true;
        }

        if (isNumeric(column.type) && !isNumeric(value?.type)) {
            return false;
        }

        if (isDate(column.type) && !isDate(value?.type)) {
            return false;
        }

        return true;
    }
};
export const FiltersSchema = Yup.array().of(
    Yup.object({
        column: Yup.object().required(),
        operator: Yup.object().required(),
        value: Yup.mixed()
            .when('operator', {
                is: (op) =>
                    op?.name === OPS.IN ||
                    op?.name === OPS.NOT_IN ||
                    op?.name === OPS.ARRAYS_OVERLAP,
                then: () => Yup.array().required().min(1).nullable().test(TYPE_TEST)
            })
            .when(['column', 'operator'], {
                is: (column, op) => isNumeric(column?.type) && op?.name === OPS.BETWEEN,
                then: () =>
                    Yup.array().of(Yup.number()).required().min(2).max(2).nullable().test(TYPE_TEST)
            })
            .when(['column', 'operator'], {
                is: (column, op) => !column?.type && op?.name === OPS.BETWEEN,
                then: () => Yup.array().required().min(2).max(2).nullable().test(TYPE_TEST)
            })
            .when(['column', 'operator'], {
                is: (column, op) => isBoolean(column?.type) && op?.name === OPS.EQ,
                then: () =>
                    Yup.string()
                        .matches(/(true|false)/)
                        .required()
                        .test(TYPE_TEST)
            })
            .when(['column', 'isRelative', 'operator'], {
                is: (column, isRelative, op) =>
                    !isBoolean(column?.type) &&
                    !isRelative &&
                    hasRhs(op?.name) &&
                    op?.name !== OPS.IN &&
                    op?.name !== OPS.NOT_IN &&
                    op?.name !== OPS.BETWEEN &&
                    op?.name !== OPS.ARRAYS_OVERLAP &&
                    op?.name !== OPS.NOT_BETWEEN,
                then: () =>
                    Yup.object({
                        name: Yup.string().required()
                    })
                        .required()
                        .nullable()
                        .test(TYPE_TEST)
            })
            .test(TYPE_TEST)
    })
);
